import { createSlice } from "@reduxjs/toolkit";
import { LOCALES } from "../../../constants";

const getLang = () => {
    const raw = localStorage.getItem("language");

    if (!raw || raw === "ko") {
        localStorage.setItem("language", LOCALES.KO);
        return LOCALES.KO;
    }
    if (raw === "en") {
        localStorage.setItem("language", LOCALES.EN);
        return LOCALES.EN;
    }
    return raw;
};

const langSlice = createSlice({
    name: "lang",
    initialState: {
        value: getLang(),
    },
    reducers: {
        toggle: (state, action) => {
            state.value = action.payload.obj.value;

            // state.value = state.value === LOCALES.KO ? LOCALES.EN : LOCALES.KO;
            localStorage.setItem("language", action.payload.obj.value);
        },
    },
});

export const { toggle } = langSlice.actions;

export default langSlice.reducer;
